import * as actions from "../actions/account";
import update from "immutability-helper";
import { setSafe } from "../../../util/storeHelper";
/**
 * reducer for changes to the authentication
 */
export const accountReducer = {
    reducers: {
        [actions.setUserAPIKey]: (state, payload) => update(state, { APIKey: { $set: payload } }),
        [actions.clearOAuthCredentials]: (state, payload) => setSafe(state, ["OAuthCredentials"], undefined),
        [actions.setOAuthCredentials]: (state, payload) => update(state, { OAuthCredentials: { $set: { ...payload } } }),
        [actions.setForcedLogout]: (state, value) => setSafe(state, ["ForcedLogout"], value),
    },
    defaults: {
        APIKey: undefined,
        OAuthCredentials: undefined,
        ForcedLogout: false,
    },
};
